<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          STATUS：
        </span>
        <el-tag
          style="font-size: 12px"
          size="mini"
          :type="
            formData.amzControlParamsStatus === 'Y'
              ? 'success'
              : formData.amzControlParamsStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_amzControlParamsStatus || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      size="mini"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <div class="title mt-2 mb-2">
        {{ $l('title_sales_markert') || '售卖市场' }}
      </div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_amzMarketCode') || '市场'"
            prop="marketId"
          >
            <dict-select
              v-model="formData.marketId"
              url="/ecom/amz/market/dictSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              :disabled="isConfirmEdit"
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_regionCode') || '所属地区'"
            prop="regionCode"
          >
            <dict-select
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              url="/master/common/dict/biz"
              :body="regionParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_exchangeCurrencyUnit') || '市场货币'"
            prop="currency"
          >
            <dict-select
              v-model="formData.currency"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              :disabled="isConfirmEdit"
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title mt-2 mb-2">
        {{ $l('title_ategory_amz_fee') || '分类及亚马逊费用' }}
      </div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_categoryCode') || '分类'"
            prop="categoryCode"
          >
            <el-cascader
              :options="categoryTree"
              :props="{
                emitPath: false,
                checkStrictly: false,
                value: 'value',
                label: 'label',
              }"
              size="mini"
              ref="cascaderCategoryTreeRef"
              v-model="formData.categoryCode"
              clearable
              filterable
              :disabled="isConfirmEdit"
              style="width: 100%"
              :showAllLevels="false"
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.label }}</span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_commissionRate') || '佣金比例(%)'"
            prop="commissionRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.commissionRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_advertisingRate') || '广告比例(%)'"
            prop="advertisingRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.advertisingRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_storageUnitPrice') || '仓储单价'"
            prop="storageUnitPrice"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.storageUnitPrice"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_inStorageMonth') || '在库时长（月）'"
            prop="inStorageMonth"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.inStorageMonth"
              :precision="0"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_salesReturnRate') || '退货率(%)'"
            prop="salesReturnRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.salesReturnRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title mt-2 mb-2">
        {{ $l('title_freight') || '运费' }}
      </div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shipUnitPrice') || '头程单价'"
            prop="shipUnitPrice"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.shipUnitPrice"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_truckingFee') || '货代卡车费'"
            prop="truckingFee"
          >
            <InputFormat :disabled="disabled" v-model="formData.truckingFee" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_freightFee') || '货代头程运费'"
            prop="freightFee"
          >
            <InputFormat :disabled="disabled" v-model="formData.freightFee" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title mt-2 mb-2">
        {{ $l('title_other_refunds_vat') || '境外关税及消费税' }}
      </div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_tariffsRate') || '关税税率(%)'"
            prop="tariffsRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.tariffsRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_salesTax') || '消费税(%)'"
            prop="salesTax"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.salesTax"
              isPercentage
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_localTax') || '地方税(%)'"
            prop="localTax"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.localTax"
              isPercentage
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_vatRate') || '增值税率(%)'"
            prop="vatRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.vatRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title mt-2 mb-2">
        {{ $l('title_cn_refunds_vat') || '国内退税及增值税' }}
      </div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_refundTaxRate') || '退税率(%)'"
            prop="refundTaxRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.refundTaxRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_chinaVatRate') || '中国增值税率(%)'"
            prop="chinaVatRate"
          >
            <InputFormat
              :disabled="disabled"
              v-model="formData.chinaVatRate"
              isPercentage
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import InputFormat from '../input-format'
export default {
  mixins: [EditLoading],
  components: { InputFormat },
  props: {
    disabled: { type: Boolean, default: false },
    isConfirmEdit: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    amzControlParamsCode: { type: String, default: '' },
  },
  data() {
    return {
      regionParams: { dictType: 'region' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      categoryTree: [],
      formData: {
        // commissionRate: 0,
        // storageUnitPrice: 0,
        // shipUnitPrice: 0,
        // tariffsRate: 0,
        // refundTaxRate: 0,
        // vatRate: 0,
        // truckingFee: 0,
        // freightFee: 0,
      },
      rules: {
        marketId: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currency: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        commissionRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        advertisingRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        storageUnitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        inStorageMonth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        salesReturnRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        shipUnitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        tariffsRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        salesTax: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        localTax: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        vatRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        refundTaxRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        chinaVatRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        truckingFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        freightFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getTreeData()
    this.getData()
  },
  methods: {
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi({ parentCode: 'ABSHome' })
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    async getData() {
      if (!this.amzControlParamsCode) return
      let res = undefined
      if (this.isCopy) {
        res = await this.$api
          .ecomAmzPriceControlParamsCopyApi({
            amzControlParamsCode: this.amzControlParamsCode,
          })
          .catch(() => null)
      } else {
        res = await this.$api
          .ecomAmzPriceControlParamsDetailApi({
            amzControlParamsCode: this.amzControlParamsCode,
          })
          .catch(() => null)
      }
      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzPriceControlParamsSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.title {
  height: 23px;
  line-height: 23px;
  color: #101010;
  font-size: 14px;
  font-weight: 600;
}
</style>
